<template>
  <div>
    <h1>前言(郭醫師的話)</h1>

    <MyCkEditor v-model="dataText" height="600px" ></MyCkEditor>
<!--    <h2>詳細內容</h2>-->
<!--    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i>新增</a>-->
<!--    <table class="table table-hover" id="tblMain">-->
<!--      <thead class="thead-light">-->
<!--      <tr>-->
<!--        <th class="text-center">功能</th>-->
<!--        <th>圖片</th>-->
<!--        <th>日期</th>-->
<!--        <th>說明</th>-->
<!--        <th>備註</th>-->
<!--      </tr>-->
<!--      </thead>-->
<!--      <tbody>-->
<!--      <tr v-for="(item,index) in this.datas" :key="index">-->
<!--        <td class="text-center">-->
<!--          <a class="btn btn-primary" @click="DataItem_Insert(item)"><i class="fas fa-plus-circle"></i> Edit</a>-->
<!--          <a class="btn btn-danger" @click="DataItem_Remove(item)"><i class="far fa-trash-alt"> Remove </i></a>-->
<!--          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i> Up </a>-->
<!--          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i> Down </a>-->
<!--        </td>-->
<!--        <td width="120px">-->
<!--          <img :src="item.imgSrc" style="width:300px;height: 200px">-->
<!--        </td>-->
<!--        <td width="100px">-->
<!--          {{item.date}}-->
<!--        </td>-->
<!--        <td>-->
<!--          {{item.text}}-->
<!--        </td>-->
<!--        <td>-->
<!--          {{item.desc}}-->
<!--        </td>-->
<!--      </tr>-->

<!--      </tbody>-->
<!--    </table>-->
  </div>
</template>

<script>
import MyCkEditor from "@/views/taylorAdmin/component/MyCkEditor";
/**

 **/

import arrayUtil from "../../util/arrayUtil";
import util from "../../util/util";
export default {
  components: {MyCkEditor},
  //name: "contentEdit",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      dataText:"脊髓損傷傷友基本資料說明\n" +
          "\n" +
          "脊髓損傷的人，受傷的部位可能在頸髓、胸髓、腰髓、薦髓或是馬尾；也可能是完全性或是不完全性的損傷；或是只有周邊神經受損。這些受傷的部位以其受傷的程度，都會影響到泌尿系統，尤其是排尿的功能。\n" +
          "\n" +
          "因此，會產生各種不同的排尿障礙，以及影響到上泌尿道的健康。如果沒有良好的排尿訓練，以及正確的排尿處置，很可能會造成腎臟水腫、反覆性尿路感染，進而影響到腎功能。高位損傷的人，也可能因為自主神經反射亢進，而產生高血壓，甚至腦中風。因此所有脊髓損傷的傷友，都必須要定期接受健康檢查。\n" +
          "\n" +
          "不論是受傷一年或是二十年，泌尿系統隨時在變化，也可能會產生嚴重程度不一的後遺症。因此，對於脊髓損傷者的泌尿系統照護是刻不容緩的事。對於身體的定期檢查，有助於設計最好的排尿處置，減少泌尿系統併發症，維持身體的健康。\n" +
          " \n",

      datas:[
        {
          imgSrc:"http://127.0.0.1:8000/ui/images/act01.jpg",
          date:"2021-10-20",
          text:"第1222次例會",
          desc:"內文說明活動說明照片說明",
        },
        {
          imgSrc:"http://127.0.0.1:8000/ui/images/act02.jpg",
          date:"2021-10-20",
          text:"第1221次例會",
          desc:"內文說明活動說明照片說明",
        },
        {
          imgSrc:"http://127.0.0.1:8000/ui/images/act03.jpg",
          date:"2021-10-20",
          text:"第1220次例會",
          desc:"內文說明活動說明照片說明",
        },
        {
          imgSrc:"http://127.0.0.1:8000/ui/images/act04.jpg",
          date:"2021-10-20",
          text:"第1219次例會",
          desc:"內文說明活動說明照片說明",
        },
      ]
    };
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    submit(){
      for (let i = 0; i < this.datas.Details.length; i++) {
        let item = this.datas.Details[i];

        if (item.Year===""){
          util.showErrorMessage("第"+i+1+" 行，「年」為必填欄位")
          return;
        }
        if (item.Month===""){
          util.showErrorMessage("第"+i+1+" 行，「月」為必填欄位")
          return;
        }
        if (item.Type===""){
          util.showErrorMessage("第"+i+1+" 行，「幣別」為必填欄位")
          return;
        }
        if (item.Rate===""){
          util.showErrorMessage("第"+i+1+" 行，「匯率」為必填欄位")
          return;
        }
      }

      // apiGPK.api_Save_datas(this.datas.SystemId,"",this.datas).then((data)=>{
      //   util.ShowMessage('儲存成功')
      // })
    },

    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.Id,this.datas,"Id","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.Id,this.datas,"Id","OrderKey")
    },
    DataItem_AddLast(){
      let newItem={
        Id:util.uuid(),
        Year:0,
        Moneth:0,
        Type:"",
        Rate:0,
        OrderKey:0,
      }

      arrayUtil.orderAppendLast(newItem,this.datas,"OrderKey")
    },
    DataItem_Insert(currentItem){
      // let newItem={
      //   Id:util.uuid(),
      //   imgSrc:"",
      //   date:"2021-10-20",
      //   text:"",
      //   desc:"",
      // }
      //
      // arrayUtil.orderInsert(newItem,currentItem,this.datas,"Id","OrderKey")
      //
      this.$router.push({
        path: "/contentDetailEdit",
        // path: item.url,
      });
    },
    DataItem_Remove(item){
      arrayUtil.removeByPredicate(this.datas,s => s.Id===item.Id);
    },

  },
  mounted() {
    //this.loadData()
  },
}
</script>


<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  width: 40px;
}
</style>
